"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchTypeToUnit = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.searchTypeToUnit = function (searchType, allIsMillion) {
    if (searchType === SfilterTypeGroup_1.SfilterType.BUY)
        return 1000000;
    if (searchType === SfilterTypeGroup_1.SfilterType.RENT)
        return 1000;
    if (searchType === SfilterTypeGroup_1.SfilterType.ALL)
        return allIsMillion ? 1000000 : 1000;
    return 1;
};
